import React from 'react';
import MUIDeleteIcon from '@mui/icons-material/Delete';
import { SvgIconProps } from '@mui/material/SvgIcon';

const DeleteIcon = ({
  color,
}: SvgIconProps) => (
  <MUIDeleteIcon color={color ?? 'primary'} />
);

export default DeleteIcon;
